<div class="flex flex-col gap-6">
  <div class="w-full">
    <zaeper-card>
      <p-button (onClick)="openCreateWidgetModal()" [rounded]="true">Widget erstellen</p-button>
    </zaeper-card>
  </div>
  <div class="grid w-full cols-auto-fill-[350px] gap-6">
    @for (widget of widgets$(); track widget) {
      <app-application-overview-item (onClick)="openWidgetDetailPage(widget.id)" [application]="widget" styleClass="cursor-pointer">
        <ng-template #actions>
          <p-button (onClick)="deleteWidget($event, widget)" icon="pi pi-trash" [rounded]="true" severity="secondary" />
        </ng-template>
      </app-application-overview-item>
    }
  </div>
</div>
